import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ModalItem,
    ButtonItem,
    Form,
    FormItem,
    InputItem,
    ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import corteCajaPdf from "../../../../Pdf/corteCajaPdf";
import ticketCorteCajaPdf from "../../../../Pdf/ticketCorteDeCaja";
import qz from "qz-tray";
import printJS from "print-js";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfCorteDeCaja extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "sesionesPV/datosCorteDeCajaPdf",
                { sesionId: this.props.id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    if( this.props.imprimirTicket || true){
                        this.printTicket(res.data);
                    }
                    if (res.data?.correosEnvio?.length > 0 && this.formRef.current) {
                        this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio })
                    }
                    const pdf = pdfMake.createPdf(corteCajaPdf(res.data));
                    this.setState(
                        {
                            loading: false,
                            pdf: pdf,
                            factura: res.data.factura
                        },
                        () => {
                            pdf.open({}, window.frames["corteCajaPdf"]);
                        }
                    );
                } else {
                    message.error("No se pudo obtener los datos del corte de caja");
                    this.setState({ loading: false });
                }
            });
        this.setState({ loading: false });
    }
    printTicket = async (dataTicket) => {
        try {

            if (!this.props.impresoraSeleccionada) {
                throw new Error("No hay impresora seleccionada");
            }

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect();
            }

            const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
                {
                    encoding: 'Cp1252',
                    scaleContent: false,     // No escalar el contenido del PDF
                    rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
                    density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
                }
            );


            // const data = ticketEscPos(dataTicket);
            const pdf2 = ticketCorteCajaPdf(dataTicket);
            const base64_1 = await new Promise((resolve) => {
                pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
            });

            await qz.print(config, [
                {
                    type: 'pixel',
                    format: 'pdf',
                    flavor: 'base64',
                    data: base64_1
                },
            ]);


            await qz.websocket.disconnect();
            // await qz.print(config, data);

        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            const pdf2 = ticketCorteCajaPdf(dataTicket);
            pdfMake.createPdf(pdf2).getBlob((blob) => {
                const pdfURL = URL.createObjectURL(blob);

                const ua = navigator.userAgent || "";
                const isAndroid = /Android/i.test(ua);

                // Chrome en iOS aparece como "CriOS"
                const isChromeiOS = /CriOS/i.test(ua);

                // WebView Android común (opcional pero útil)
                const isWebViewAndroid =
                isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

                // ❌ Navegadores que NO pueden con printJS → visor directo
                if (isAndroid || isWebViewAndroid || isChromeiOS) {
                const win = window.open(pdfURL, "_blank");
                if (!win) window.location.href = pdfURL;
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
                return;
                }

                // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
                // Intentamos printJS y NO hacemos fallback si falla
                try {
                printJS({
                    printable: pdfURL,
                    type: "pdf",
                    showModal: false,
                });
                } catch (e) {
                // Si falla de inmediato, NO hacemos nada más
                message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
                console.warn("printJS falló inmediatamente:", e);
                }

                // No revocar rápido o rompes printJS
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
            });
        }
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        if (values?.correosEnvio?.length > 0) {
            this.setState({ loading: true });
            axios
                .post(
                    "sesionesPV/enviarCorteDeCajaPdf",
                    { ...values, sesionId: this.props.id, empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    if (res.data.success === 2) {
                        message.success("Se ha enviado correctamente el corte de caja");
                        this.formRef.current.resetFields();
                        this.cerrarModalPdfCorteDeCaja();
                    } else if (res.data.success === 1) {
                        message.error(res.data.message || "Sucedio un error y no se pudo enviar");
                    } else {
                        message.error("Sucedio un error y no se pudo enviar");
                    }
                });
        } else {
            message.info('Proporcione al menos un correo de envio')
        }
    }
    cerrarModalPdfCorteDeCaja() {
        this.formRef.current.resetFields()
        this.props.cerrarModalPdfCorteDeCaja();
    }
    render() {
        return (
            <ModalItem
                title="Vista previa"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalPdfCorteDeCaja.bind(this)}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="ModalPdfCorteDeCaja"
                    layout
                    width={700}
                    onCancel={this.cerrarModalPdfCorteDeCaja.bind(this)}
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormInitial.List
                        name="correosEnvio"
                        initialValue={[{ correo: '' }]}
                    >
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ name }, arrayKey) => (
                                    <Row>
                                        <Col span={22}>
                                            <FormItem
                                                name={[name, "correo"]}
                                                fieldKey={[arrayKey, "correo"]}
                                                label='Correo'
                                                required
                                                margin
                                                email
                                                pattern
                                            >
                                                <InputItem style={{ width: '100%' }} placeholder="Correo" />
                                            </FormItem>
                                        </Col>
                                        <Col span={2}>
                                            <div style={{ textAlign: 'center' }}>
                                                <MinusCircleOutlined
                                                    onClick={() => remove(name)}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                ))}
                                {fields.length < 5 ?
                                    <div style={{ textAlign: 'center', marginTop: '5px' }}>
                                        <ButtonItem
                                            type="primary"
                                            onClick={() => add()}
                                            icon={<PlusOutlined />}
                                        >
                                            Agregar
                                        </ButtonItem>
                                    </div>
                                    : null}
                            </>
                        )}
                    </FormInitial.List>
                    <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
                        <Space>
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Mandar Correo
                            </ButtonItem>
                            <ButtonItem
                                type="primary"
                                danger
                                onClick={this.cerrarModalPdfCorteDeCaja.bind(this)}
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Cancelar
                            </ButtonItem>
                        </Space>
                    </div>
                </Form>
                <iframe
                    title={"corte de caja"}
                    style={{ width: "100%", height: "100vh" }}
                    id="corteCajaPdf"
                    name="corteCajaPdf"
                />
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(ModalPdfCorteDeCaja);
